
import "../../assets/outline-directions_run-24px.svg";
import "../../assets/outline-check_circle_outline-24px.svg";
import "../../assets/outline-cancel_presentation-24px.svg";
import "../../assets/outline-error_outline-24px.svg";

import Component from "vue-class-component";
import { getThemedStatusColor, cssStripe } from "../palette";
import JobStatusCard from "./JobStatusCard.vue";

@Component({
  props: {
    job: { type: Object },
  },
  filters: {},
})
export default class JobStatusPip extends JobStatusCard {
  getThemedStatusColor = getThemedStatusColor;
  cssStripe = cssStripe;

  askCancelJob(job_id: string) {
    this.$emit("cancel", job_id);
  }
}
